module.exports = __webpack_public_path__ + "static/img/9_red.05bf1d3a.jpg";